import React from "react";
import LoginService from "../../login/loginService";
import OtpModal from "../otp-modal/OtpModal";
import { Modal, InputGroup, Button } from "react-bootstrap";
import { toast , ToastContainer } from "react-toastify";
import LoadSpinner from "../../../common/spinner/loadSpinner";

export default class ChangePasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      showConfirmModal: false,
      loading: false,
    };
  }

  changeText(field, event) {
    this.setState({ [field]: event.target.value });
  }

  submitPasswordChange() {
      const {
        cid,
        cfAzienda,
        temporaryToken,
        loginService,
        onSuccess,
        onError,
      } = this.props;
      
      const {oldPassword, newPassword, confirmPassword } = this.state;

      if (newPassword === oldPassword) {
        toast.warning("La nuova password non può essere uguale a quella attuale.");
        return;
      }

      if (newPassword !== confirmPassword) {
        toast.error("Le due password inserite non coincidono. Riprova.");
        return;
      }

      loginService.changePassword(
        oldPassword,
        newPassword,
        () => {
          this.setState({
            showConfirmModal: false,
            newPassword: '',
            confirmPassword: '',
            loading: false,
          });
          this.resetState();
          toast.success("Password cambiata con successo, effettua il login.");
          onSuccess("Password cambiata con successo, effettua il login." , newPassword);
          
        },
        (error) => {
          console.error("Errore durante il cambio password:", error);
          toast.error("Errore durante il cambio password.");
          onError("Errore durante il cambio password.");
        },
        temporaryToken,
        cfAzienda,
      );
    }
    checkPasswordStrength() {
      const passwordRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/);
      
      return !(passwordRegex.test(this.state.oldPassword) &&
             passwordRegex.test(this.state.newPassword) &&
             passwordRegex.test(this.state.confirmPassword)&&
             this.state.newPassword === this.state.confirmPassword &&
             this.state.oldPassword !== this.state.newPassword
    );
  }

    resetState() {
      this.setState({
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      showConfirmModal: false,
      errorMessage: '',
      successMessage: '',
    });
}

  render() {
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.state.loading ? null : this.props.onClose}
      
        >
          <Modal.Header closeButton>
            <Modal.Title>Cambio Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-danger m-0 mb-2">
                Hai 5 minuti per effettuare il cambio prima che la sessione scada.
                Trascorso tale periodo, sarà necessario inoltrare una nuova richiesta.
            </p>
              {/* {this.state.errorMessage && (
              <div style={{ color: "red", marginBottom: "10px" }}>
                {this.state.errorMessage}
              </div>
              )}
              {this.state.successMessage && (
                <div style={{ color: "green", marginBottom: "10px" }}>
                  {this.state.successMessage}
                </div>
              )} */}
            <label>Vecchia Password</label>
            <InputGroup className="mb-2">
              <input
                type={this.state.showOldPassword ? "text" : "password"}
                className="form-control"
                minLength="8"
                maxLength="32"
                placeholder="Vecchia Password"
                value={this.state.oldPassword}
                onChange={this.changeText.bind(this, "oldPassword")}
              />
              <Button
                onClick={() =>
                  this.setState({
                    showOldPassword: !this.state.showOldPassword,
                  })
                }
              >
                {this.state.showOldPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                  </svg>
                )}
              </Button>
            </InputGroup>
            <label>Nuova Password</label>
            <InputGroup className="mb-2">
              <input
                type={this.state.showNewPassword ? "text" : "password"}
                className="form-control"
                minLength="8"
                maxLength="32"
                placeholder="Nuova Password"
                value={this.state.newPassword}
                onChange={this.changeText.bind(this, "newPassword")}
              />
              <Button
                onClick={() =>
                  this.setState({
                    showNewPassword: !this.state.showNewPassword,
                  })
                }
              >
                {this.state.showNewPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                  </svg>
                )}
              </Button>
            </InputGroup>

            <label>Conferma Password</label>
            <InputGroup>
              <input
                type={this.state.showConfirmPassword ? "text" : "password"}
                className="form-control"
                minLength="8"
                maxLength="32"
                placeholder="Conferma Password"
                value={this.state.confirmPassword}
                onChange={this.changeText.bind(this, "confirmPassword")}
              />
              <Button
                onClick={() =>
                  this.setState({
                    showConfirmPassword: !this.state.showConfirmPassword,
                  })
                }
              >
                {this.state.showConfirmPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-slash-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                    <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-eye-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                  </svg>
                )}
              </Button>
            </InputGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
                variant="secondary"
                onClick={() => {
                  this.resetState();
                  this.props.onClose();
                }}
                disabled={this.state.loading}
              >
                Annulla
              </Button>
              <Button
                variant="primary"
                onClick={this.submitPasswordChange.bind(this)}
                disabled={this.state.loading || this.checkPasswordStrength() }
              >
                {this.state.loading ? (
                  <LoadSpinner/>
                ) : (
                  "Cambia Password"
                )}
              </Button>
          </Modal.Footer>
        </Modal>

        {/* <Modal
          show={this.state.showConfirmModal}
          onHide={() => this.setState({ showConfirmModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Conferma Cambio Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sei sicuro di voler cambiare la password?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfirmModal: false })}>
              Annulla
            </Button>
            <Button variant="primary" onClick={this.submitPasswordChange.bind(this)}>
              Conferma
            </Button>
            
          </Modal.Footer>
        </Modal> */}
        <ToastContainer position="top-right" autoClose={3000} />
      </>
    );
  }
}